export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-html5-d034ab6e71994c286b233d54bc373bdd.svg";